
import React, {FC} from 'react';
import {TimeSlot} from 'components/TimePicker/types';

import Section from './Section';

import * as styles from './styles.module.scss';

type TimeListProps = {
	timeSlots: TimeSlot[],
	selected?: TimeSlot,
	sectioned: boolean,
	onSelect: (v?: TimeSlot) => void
}

enum SectionTitle {
	Morning = 'Morning',
	Afternoon = 'Afternoon',
	Evening = 'Evening',
}

type Section = {
	title: keyof typeof SectionTitle
	timeSlots: TimeSlot[]
}

const sectionTitle = (slot: TimeSlot): SectionTitle => {
	const hour = Number(slot.time24h.split(':')[0]);
	if (hour < 12) {
		return SectionTitle.Morning;
	} else if (hour < 18) {
		return SectionTitle.Afternoon;
	}
	return SectionTitle.Evening;
};

const sections = (slots: TimeSlot[]): Section[] => {
	type Groups = {
		[P in Section['title']]?: TimeSlot[];
	}

	// Split our slots into groups by section title
	const groups: Groups = slots
		.reduce((acc: Groups, curr) => {
			const title = sectionTitle(curr);
			return {
				...acc,
				[title]: [...(acc[title] || []), curr],
			};
		}, {});

	// Map into an array of sections
	return Object.values(SectionTitle)
		.map((title) => ({
			title,
			timeSlots: groups[title] || [],
		}))
		.filter((section) => section.timeSlots.length > 0);
};

const TimeList: FC<TimeListProps> = ({sectioned, ...rest}) => {
	if (rest.timeSlots.length === 0) {
		return null;
	}

	if (sectioned) {
		return (
			<div className={styles.sections}>
				{sections(rest.timeSlots).map((s) => (
					<Section {...rest} {...s} key={s.title} />
				))}
			</div>
		);
	}

	return (
		<div className={styles.sections}>
			<Section {...rest} truncate />
		</div>
	);
};

export default TimeList;
